import React from 'react';
import { useTranslate } from '../../../mixins/translate/translate';
import { PanelBody, PanelHeading, PanelLink, Table, TableBody, TableData, TableHead, TableHeader, TableRow } from '../../elements';
import { IInspectionPlan } from '../Interfaces/IInspectionPlan';

export function InspectionPlans(props: { inspectionPlans: IInspectionPlan[]; surveyId: string }) {
    const translate = useTranslate();
    return (
        <div className="panel" id="InspectionPlans">
            <PanelHeading text={translate('survey.inspectionPlans')} icon="fa fa-calendar-o">
                <PanelLink
                    href={`/api/surveys/${props.surveyId}/inspectionPlans/export`}
                    text="Export"
                    isDownload
                    icon="fa fa-download"
                    small
                ></PanelLink>
            </PanelHeading>
            <PanelBody noPadding={true}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableHeader>{translate('common.location')}</TableHeader>
                            <TableHeader>{translate('common.description')}</TableHeader>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.inspectionPlans.map((inspectionPlan) => {
                            return (
                                <TableRow key={inspectionPlan.id}>
                                    <TableData>
                                        <div>{inspectionPlan.unit.element.name}</div>
                                        <div>{inspectionPlan.unit.name}</div>
                                        {inspectionPlan.manifestation && <div>{inspectionPlan.manifestation.name}</div>}
                                    </TableData>
                                    <TableData>{inspectionPlan.description}</TableData>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </PanelBody>
        </div>
    );
}
